import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

export const getNotifications = async () => {
  const response = await axios.get(`${API_URL}/notification-center`, getHeaders());
  return response.data;
};

export const getUnreadCount = async () => {
  const response = await axios.get(`${API_URL}/notification-center/count`, getHeaders());
  return response.data.count;
};

export const markAsRead = async (id) => {
  const response = await axios.put(`${API_URL}/notification-center/${id}/read`, {}, getHeaders());
  return response.data;
};

export const markAllAsRead = async () => {
  const response = await axios.put(`${API_URL}/notification-center/read-all`, {}, getHeaders());
  return response.data;
};

export const clearNotifications = async () => {
  const response = await axios.delete(`${API_URL}/notification-center/clear`, getHeaders());
  return response.data;
};
